const ProjectsData = [
    {
        name: "LinuxDistro4U",
        mainTech: "JavaScript",
        link: "https://github.com/HaiderSultanArc/LinuxDistro4U",
        
        description: {
            text: "Choosing a Linux Distro can be difficult as there is a ton of options to go with. So, I made this little website. It's a Questionnaire based website that uses Machine Learning to predict the Linux Distro that will best suit you, based on your response. It makes the choice for you and gives a single best name of the distro for your priorities.",
            technologies: ["ReactJS", "TensorFlow.Keras", "TensorFlowJS", "SCSS", "Firebase"],
        },
    },
    {
        name: "AI-Insights",
        mainTech: "Python",
        link: "https://github.com/HaiderSultanArc/AI-Insights",
        
        description: {
            text: "This project contains Machine Learning Problems and their solutions from scratch as well as using Libraries. The Goal is to make a step by step guided project repo for Machine Learning.",
            technologies: ["TensorFlow", "Keras", "NumPy", "Pandas", "Matplotlib", "Seaborn"],
        },
    },
    {
        name: "Application Clones",
        mainTech: "JavaScript",
        link: "https://github.com/HaiderSultanArc/Clones",
        
        description: {
            text: "This project consists of clones of famous applications. The purpose of this project was to understand the thinking of Tech Giants while developing their applications.",
            technologies: ["ReactJS", "Flutter"],
        },
    },
    {
        name: "Academic Projects",
        mainTech: "C++",
        link: "https://github.com/HaiderSultanArc/AcademicProjects",
        
        description: {
            text: "This repo consists of all my Semester Projects in University.",
            technologies: ["C++"],
        },
    },
];

export default ProjectsData;


// WEBPACK FOOTER //
// ./src/Components/Projects/Data/ProjectsData.js